module.exports = __webpack_public_path__ + "img/multi-four.05cd5016.svg";